import { ApplicationConfig, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection, inject } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AuthInterceptor } from './core/interceptors/auth.interceptors';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { fr } from "primelocale/fr.json";
import { MessageService } from 'primeng/api';
import { firstValueFrom, of } from 'rxjs';
import { ShopsStore } from './core/stores/shops.store';
import { AuthService } from './core/services/auth.service';
import { provideCustomAppMenuDefinition } from './custom/app-menu.custom.definition';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withFetch(),withInterceptors([AuthInterceptor])),
    provideAnimationsAsync(),
    provideAppInitializer(() => {
      const auth = inject(AuthService);
      if (!auth.isAuthenticated()) return firstValueFrom(of([]));
      return firstValueFrom(inject(ShopsStore).loadOnce());
    }),
    provideCustomAppMenuDefinition(),
    providePrimeNG({
        theme: {
            preset: Aura,
            options: { darkModeSelector: '.app-dark' }
        },
      translation: fr,
    }),
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    MessageService,
  ]
};
